import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { ISensitiveCities } from 'src/models/sensitive-cities.model';
import services from 'src/services/sensitive-cities.service';

export const actionTypes = {
  SENSITIVE_CITIES_FETCH: 'SENSITIVE_CITIES_FETCH',
  SENSITIVE_CITIES_ADD: 'SENSITIVE_CITIES_ADD',
  SENSITIVE_CITIES_UPDATE: 'SENSITIVE_CITIES_UPDATE',
  SENSITIVE_CITIES_DELETE: 'SENSITIVE_CITIES_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.SENSITIVE_CITIES_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.SENSITIVE_CITIES_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.SENSITIVE_CITIES_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.SENSITIVE_CITIES_DELETE,
    service: services.itemDELETE,
  },
};

export type ISensitiveCitiesAsync = typeof asyncActions;

export interface ISensitiveCitiesState extends ICommonState<ISensitiveCitiesAsync> {
  data?: ISensitiveCities;
  list: ISensitiveCities[];
  total: number;
}

export const defaultState: ISensitiveCitiesState = {
  status: {},
  list: [],
  total: 0,
};

const SensitiveCitiesReducer = (
  state: ISensitiveCitiesState = defaultState,
  action: IReducerAction<ISensitiveCitiesAsync>
): ISensitiveCitiesState => {
  switch (action.type) {
    case actionTypes.SENSITIVE_CITIES_FETCH: {
      return {
        ...state,
        list: action.payload?.sensitiveCities.rows ?? [],
        total: action.payload?.sensitiveCities.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default SensitiveCitiesReducer;
